var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBottomLeftSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 47,
  fill: "none",
  viewBox: "0 0 64 47"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#a)",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  d: "M64 45H2V.882"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 0.956,
  x2: 64,
  y1: 23.334,
  y2: 23.334,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26F028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#011F21"
})))));
export { SvgBottomLeftSmall as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNDciIHZpZXdCb3g9IjAgMCA2NCA0NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTY0IDQ0Ljk5OTZIMlYwLjg4MTgzNiIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9saW5lYXJfNDYzXzY4MikiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNDYzXzY4MiIgeDE9IjAuOTU1OTI2IiB5MT0iMjMuMzM0MSIgeDI9IjY0IiB5Mj0iMjMuMzM0MSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMjZGMDI4Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAxMUYyMSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";